<template>
<div class="chapter">
<div class="inner_page">
<div id="toc"><h1 id="toc-title">Schoolhouse Burning</h1><ol class="toc"><li id="toc-li-1"><a href="#/text/ch001#copyright-information">Copyright Information ©</a></li><li id="toc-li-2"><a href="#/text/ch002#acknowledgment">Acknowledgment</a></li><li id="toc-li-3"><a href="#/text/ch003#introduction">Introduction</a></li><li id="toc-li-4"><a href="#/text/ch004#chapter-i-the-welcome-stranger-a-true-short-story">Chapter I The Welcome Stranger – A True Short Story</a></li><li id="toc-li-5"><a href="#/text/ch005#values-and-principles-a-poem">Values and Principles – A Poem</a></li><li id="toc-li-6"><a href="#/text/ch006#chapter-ii-schoolhouse-burning">Chapter II Schoolhouse Burning</a></li><li id="toc-li-7"><span href="#/text/ch007#chapter-iii-strengthening-the-administration-of-justice" title="Link target outside of Sample">Chapter III Strengthening the Administration of Justice</span></li><li id="toc-li-8"><span href="#/text/ch008#chapter-iv-the-republic-of-jerusalem" title="Link target outside of Sample">Chapter IV The Republic of Jerusalem</span></li><li id="toc-li-9"><span href="#/text/ch009#chapter-v-a-case-study-in-self-hypnosis" title="Link target outside of Sample">Chapter V A Case Study in Self-Hypnosis</span></li><li id="toc-li-10"><span href="#/text/ch010#bibliography-and-supporting-resources" title="Link target outside of Sample">Bibliography and Supporting Resources</span></li><li id="toc-li-11"><span href="#/text/ch011#about-the-author" title="Link target outside of Sample">About the Author</span></li><li id="toc-li-12"><span href="#/text/ch012#dedication" title="Link target outside of Sample">Dedication</span></li></ol></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?b0a9a29a